import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type Session from "cc-frontend/services/session"
import type StandardsModalService from "cc-frontend/services/standards-modal"

/**
 * Component that renders the standards modal for the StandardsModal service.
 */
export default class StandardsModal extends Component {
  @service declare session: Session
  @service declare standardsModal: StandardsModalService
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    StandardsModal: typeof StandardsModal
  }
}
